import { Component, Inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import Swal from "sweetalert2";
import { LicenseService } from "../../../services/LicenseService";
import { IBillingShippingModel } from "../../../interfaces/LicenseModel";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./generate-smartlink360-license.component.html'),
    styles:[require('./generate-smartlink360-license.component.css')],
    selector:'generate-smartlink360-license'
})
export class GenerateSmartLink360LicenseComponent{
    dialogTitle='Generate New License Request';
    errorMessage='';
    smartLink360LicenseForm;
    shouldFetchSalesOrderNo=true;
    error='';
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    isBillingShippingDetailFetched=false;
    SelectedLicenseDetail;
    smartLink360PurchaseLicenseData;
    prevSalesOrderNo='';
    constructor(
        public dialogRef:MdDialogRef<GenerateSmartLink360LicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.smartLink360PurchaseLicenseData=this.dialogData.Smartlink360PurchaseLicenseData;
        this.SelectedLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        
        if(this.SelectedLicenseDetail){
            this.dialogTitle="Edit License Request";
            this.smartLink360LicenseForm.patchValue({
                PurchaseInvoiceDate:this.SelectedLicenseDetail.PurchaseDate.toString().split('T')[0],
                SupportValidityYear:this.SelectedLicenseDetail.NoOfMonths,
                SalesOrderNo:this.SelectedLicenseDetail.SalesOrderNo,
            })
            this.isBillingShippingDetailFetched=true;
            this.prevSalesOrderNo=this.SelectedLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName=this.SelectedLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedLicenseDetail.ShipToState;
        }
        else{
            this.dialogTitle='Generate New License Request';
        }
    }
    buildForm(){
        this.smartLink360LicenseForm=this.formBuilder.group({
            PurchaseInvoiceDate:['',[Validators.required]],
            SupportValidityYear:['',[Validators.required]],
            SalesOrderNo:['',[Validators.required]]
        })
    }
    onCancel(){
        this.dialogRef.close(this.smartLink360PurchaseLicenseData);
    }

    blurSalesOrderEvent(){
        if(this.prevSalesOrderNo.trim().toUpperCase()==this.smartLink360LicenseForm.value.SalesOrderNo.trim().toUpperCase()){
            return;
        }
        this.prevSalesOrderNo=this.smartLink360LicenseForm.value.SalesOrderNo
        setTimeout(() => {
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
        }, 150);
    }

    checkSalesOrderNo(){
        if(this.smartLink360PurchaseLicenseData){

            let exist=this.smartLink360PurchaseLicenseData.some((element)=>{
                if(element.SalesOrderNo!=null){
                    return this.smartLink360LicenseForm.value.SalesOrderNo.trim().toUpperCase()==element.SalesOrderNo.trim().toUpperCase()
                }
                else{
                    return false;
                }
            })

            if(exist){
                Swal.fire({
                    title:"This sales order no already exists",
                    text:"Are you sure you want to use this Sales Order No?",
                    showCancelButton:true,
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonText:"Yes",
                    confirmButtonColor:"#FFCA28",
                    cancelButtonText:"No",
                }).then((result)=>{
                    if(result.isConfirmed){
                       this.shouldFetchSalesOrderNo=true;
                       this.isBillingShippingDetailFetched=false;
                       this.getBillingShippingDetail();
                    }
                    else{
                        this.shouldFetchSalesOrderNo=false;
                        this.smartLink360LicenseForm.patchValue({
                            SalesOrderNo:""
                        });
                    }
                })
            }
            else{
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
                this.getBillingShippingDetail();
            }
        }
        else{
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
            this.getBillingShippingDetail();
        }
    }
    getBillingShippingDetail(){
        let salesOrderNo=this.smartLink360LicenseForm.value.SalesOrderNo;
        if(salesOrderNo!=''){
            if(this.shouldFetchSalesOrderNo){
                this.appLoader.open()
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe((data)=>{ //get data from MAS90
                    if(!data.IsError && data.DataObject!=null){
                        this.billingShippingDetail=data.DataObject;
                        this.isBillingShippingDetailFetched=true;
                        this.error='';
                    }
                    else{
                        this.isBillingShippingDetailFetched=false;
                        this.error=data.Error;
                    }
                    this.appLoader.close()
                })
            }
            else{
                this.error="Please select other sales order number."
            }
        }
        else{
            this.error="Sales Order No is required";
            this.isBillingShippingDetailFetched=false;
        }
    }
    onSave(){
        setTimeout(() => {
            if(!this.isBillingShippingDetailFetched){
                this.error="Please fetch the customer billing and shipping details!";
                return;
            }
            if(this.SelectedLicenseDetail!=null){
                if(this.SelectedLicenseDetail.SalesOrderNo != this.smartLink360LicenseForm.value.SalesOrderNo){
                    this.appLoader.open()
                    this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                        if(data.DataObject!=null && !data.IsError){
                            let model={
                                LicenseId:this.SelectedLicenseDetail.LicenseId,
                                CustomerId:data.DataObject.CustomerId,
                                ShippingAddressId:data.DataObject.ShippingAddressId,
                                PurchaseInvoiceDate:this.smartLink360LicenseForm.value.PurchaseInvoiceDate,
                                SupportValidityYear:this.smartLink360LicenseForm.value.SupportValidityYear,
                                SalesOrderNo:this.smartLink360LicenseForm.value.SalesOrderNo
                            }
                            this.licenseService.updateSmartLink360License(model).subscribe((data)=>{
                                if(!data.IsError && data.DataObject!=null){
                                    this.smartLink360PurchaseLicenseData=data.DataObject;
                                    this.dialogRef.close(this.smartLink360PurchaseLicenseData);
                                    this.appLoader.close();
                                    this.snackBar.open("License Updated successfully!","",{
                                        duration:2000
                                    })
                                }
                                else{
                                    this.appLoader.close();
                                    this.dialogRef.close(this.smartLink360PurchaseLicenseData);
                                }
                            })
                        }
                    })
                }
                else{
                    let model={
                        LicenseId:this.SelectedLicenseDetail.LicenseId,
                        CustomerId:this.SelectedLicenseDetail.CustomerId,
                        ShippingAddressId:this.SelectedLicenseDetail.ShippingAddressId,
                        PurchaseInvoiceDate:this.smartLink360LicenseForm.value.PurchaseInvoiceDate,
                        SupportValidityYear:this.smartLink360LicenseForm.value.SupportValidityYear,
                        SalesOrderNo:this.smartLink360LicenseForm.value.SalesOrderNo
                    }
                    this.appLoader.open()
                    this.licenseService.updateSmartLink360License(model).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.smartLink360PurchaseLicenseData=data.DataObject;
                            this.dialogRef.close(this.smartLink360PurchaseLicenseData);
                            this.appLoader.close();
                            this.snackBar.open("License Updated successfully!","",{
                                duration:2000
                            })
                        }
                        else{
                            this.appLoader.close();
                            this.dialogRef.close(this.smartLink360PurchaseLicenseData);
                        }
                    })
                }
            }
            else{
                this.appLoader.open()
                this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                    let model={
                        CustomerId:data.DataObject.CustomerId,
                        ShippingAddressId:data.DataObject.ShippingAddressId,
                        PurchaseInvoiceDate:this.smartLink360LicenseForm.value.PurchaseInvoiceDate,
                        SupportValidityYear:this.smartLink360LicenseForm.value.SupportValidityYear,
                        SalesOrderNo:this.smartLink360LicenseForm.value.SalesOrderNo,
                    }
                    if(!data.IsError && data.DataObject!=null){
                        this.licenseService.generateSmartLink360License(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.smartLink360PurchaseLicenseData=data.DataObject;
                                this.appLoader.close();
                                this.dialogRef.close(this.smartLink360PurchaseLicenseData);
                                this.snackBar.open("License generated successfully!","",{
                                    duration:2000
                                })
                            }
                            else{
                                this.appLoader.close();
                                this.dialogRef.close(this.smartLink360PurchaseLicenseData);
                                 this.snackBar.open(data.Error,"",{
                                        duration:2000
                                    })
                            }
                        });
                    }
                });
            }
        }, 300);
        
    }  
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartlink360/generate-smartlink360-license/generate-smartlink360-license.component.ts